import { TypographyParagraph, TypographyLabel } from '../../typography'
import TypographyHeader from '../../typography/TypographyHeading'
import { NewsIcon, EyeIcon, CalendarIcon, BookIcon, LinkIcon } from '../../icons'
import { formatDateToLongFormat } from '#app/utils/timeUtils'
import InternalLink from '#app/components/common/internalLink.tsx'
import Button from '../../buttons/button'

type MediaCitationProps = {
  metadata: {
    properties: {
      title?: string;
      description?: string;
      authorName?: string;
      date?: string;
      url?: string;
    };
  };
}

export default function MediaCitation({ metadata }: MediaCitationProps) {
  const { properties } = metadata;

  return (
    <div className="flex flex-col space-y-2">
      {/* Article Title */}
      <TypographyHeader size="small" additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark">
        {properties.title || 'Untitled Article'}
      </TypographyHeader>

      {/* Publication Info */}
      <div className="flex items-center space-x-2 text-textSecondaryLight dark:text-textSecondaryDark">
				{properties.date && (
					<>
						<CalendarIcon size="small" />
						<TypographyLabel size="small">
							{properties.date ? formatDateToLongFormat(properties.date) : ''}
						</TypographyLabel>
					</>
				)}
        {properties.authorName && (
          <>
            <BookIcon size='small'/>
            <TypographyLabel size="small">
              {properties.authorName}
            </TypographyLabel>
          </>
        )}
      </div>

      {/* Article Description */}
      <TypographyParagraph size="small" additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark">
        {properties.description ? `${properties.description.slice(0, 116)}${properties.description.length > 116 ? '...' : ''}` : 'No description available'}
      </TypographyParagraph>

      {/* Article original link */}
      {properties.url && (
				<a target="_blank" rel="noreferrer" href={properties.url} className='flex flex-row space-x-1'>
					<Button variant="tertiary" size="xSmall" additionalClasses="flex flex-row space-x-0" leftIcon={<LinkIcon size="small" />}>
						Read Article
					</Button>
				</a>
			)}
    </div>
  );
} 